import { createSlice } from '@reduxjs/toolkit'

import { manageSubscription } from 'common/billing/actions/upgradeActions'
import { billingFlexApi } from 'shared/api/requests/billingFlex'

import { abilitiesUpdated } from '../actions/abilitiesActions'
import { getDefaultAbilitiesMap, parseAbilities } from '../models/Ability/helpers'
import { AbilitiesMap } from '../models/Ability/schemas'

export const abilitiesSlice = createSlice({
  name: 'abilities',
  initialState: (): AbilitiesMap => {
    const abilities = window.__INIT__?.['app.currentAccount.abilities'] || getDefaultAbilitiesMap()

    return parseAbilities(abilities)
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(abilitiesUpdated, (state, action) => {
        return parseAbilities(action.payload, state)
      })
      .addCase(manageSubscription.rejected, (state, action) => {
        const businessError = action.payload
        if (billingFlexApi.manageSubscription.isManageSubscriptionError(businessError)) {
          const { abilities } = businessError?.error_data || {}
          if (abilities) {
            return parseAbilities(abilities, state)
          }
        }

        return state
      })
      .addCase(manageSubscription.fulfilled, (state, action) => {
        return parseAbilities(action.payload.abilities, state)
      })
  },
})
